import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperGallery = () => {
  new Swiper('.swiper-gallery', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 600,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    centeredSlides: true,
    initialSlide: 2,
    breakpoints: {
      320: {
        slidesPerView: 1.05,
        spaceBetween: 0,
      },
      1440: {
        slidesPerView: 1.9,
        spaceBetween: 10,
      },
    },
  });
};

export default swiperGallery;
